import { useState } from "react";
import { useTranslation } from "react-i18next";
import PageHeadline from "../../components/shared/PageHeadline";

export default function RaceResult() {
    const [currentIndex, setCurrentIndex] = useState(0);

    const { t } = useTranslation();

    return (
        <div className="text-white md:px-0 px-4">
            <div className="
                relative
                min-h-[240px] lg:min-h-[300px]
                bg-brand-blue bg-cover md:bg-cover bg-no-repeat
                flex justify-center items-center
                mt-[86px] md:mt-[109px] 2xl:mt-[136px]
                "
            >
                <PageHeadline title={t("raceResultTitle")} />
            </div>
            <div className="top-12 relative mb-20 font-evil pb-16">
                <div className="border-2 rounded-xl border-[#164481] min-h-screen container mx-auto w-full font-evil text-[#164481] xl:py-8">
                    <div className="flex items-center justify-center flex-row gap-x-10">
                        <button
                            onClick={() => setCurrentIndex(0)}
                            className={`py-2 border-white px-8 text-lg ${currentIndex === 0 ? "font-bold border-b" : ""
                                }`}
                        >
                            2025
                        </button>
                    </div>
                    <div className="mt-8 2xl:px-0 md:px-14 px-0">
                        <iframe
                            title="Lokasi"
                            src="https://result.race.id/results.aspx?CId=20127&RId=3104"
                            allowfullscreen="true"
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                            className="w-full min-h-[calc(100vh-200px)] rounded-lg"
                        ></iframe>
                    </div>
                </div>
                {/* <div className="min-h-screen flex justify-center items-center">
                    <h1 className="md:text-4xl text-2xl font-evil font-bold italic uppercase text-brand-blue">
                        Under maintenance, will update soon
                    </h1>
                </div> */}
            </div>
        </div>
    );
}
